var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"py-4",attrs:{"flat":"","color":"primary","tile":""}},[_c('v-row',{staticClass:"white--text px-6",attrs:{"no-gutters":""}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }